import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const installSerializableFetchWrapper = () => {
  if (
    typeof window === "undefined" ||
    typeof window.fetch !== "function" ||
    typeof Request === "undefined" ||
    window.__serializableFetchWrapperInstalled
  ) {
    return;
  }

  const previousFetch = window.fetch.bind(window);

  window.fetch = async (input, init) => {
    if (!(input instanceof Request)) {
      return previousFetch(input, init);
    }

    if (init) {
      return previousFetch(input.url, init);
    }

    const requestClone = input.clone();
    const normalizedInit = {
      method: requestClone.method,
      headers: Object.fromEntries(requestClone.headers.entries()),
      cache: requestClone.cache,
      credentials: requestClone.credentials,
      integrity: requestClone.integrity,
      keepalive: requestClone.keepalive,
      mode: requestClone.mode,
      redirect: requestClone.redirect,
      referrer: requestClone.referrer === "about:client" ? undefined : requestClone.referrer,
      referrerPolicy: requestClone.referrerPolicy,
      signal: requestClone.signal,
    };

    if (!["GET", "HEAD"].includes(requestClone.method)) {
      normalizedInit.body = await requestClone.blob();
    }

    return previousFetch(requestClone.url, normalizedInit);
  };

  window.__serializableFetchWrapperInstalled = true;
};

installSerializableFetchWrapper();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
